import styled, { css } from 'styled-components';
import { FormMessage } from '../form-message/index.js';
import { getMargins, SYS_SPACE_FIXED_50, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_150, SEM_TYPOGRAPHY_FORMS_LABEL_SMALL, SEM_TYPOGRAPHY_FORMS_INPUT, SEM_TYPOGRAPHY_FORMS_APPENDIX, SEM_TYPOGRAPHY_FORMS_RANGE, SYS_SIZE_FIXED_600, SYS_SIZE_FIXED_50, SEM_BORDER_WIDTH_FORMS_DEFAULT, SEM_BORDER_RADIUS_FORMS_MAX, getTypographyStyles } from '@oneaudi/unified-web-common';
import {} from './index.js';
const injectThumb = css `
  width: var(--thumb-diameter);
  height: var(--thumb-diameter);
  border: ${SEM_BORDER_WIDTH_FORMS_DEFAULT} solid
    ${(props) => props.disabled
    ? props.theme.sem.color.forms.surface.control.stroke.disabled
    : props.invalid
        ? props.theme.sem.color.forms.surface.control.stroke.error
        : props.theme.sem.color.forms.surface.control.stroke.default};
  border-radius: ${SEM_BORDER_RADIUS_FORMS_MAX};
  background-color: ${(props) => props.disabled
    ? props.theme.cmp.color.forms.slider.surface.handle.disabled
    : props.theme.cmp.color.forms.slider.surface.handle.default};
  box-shadow: none;
  box-sizing: border-box;
  appearance: none;
  pointer-events: auto;
  z-index: 3;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'grab')};

  &:hover,
  &:active {
    border-color: ${(props) => !props.disabled && !props.invalid
    ? props.theme.sem.color.forms.surface.control.stroke.interactive
    : 'inherit'};
  }

  &:active {
    cursor: ${(props) => (!props.disabled ? 'grabbing' : 'inherit')};
  }
`;
export const StyledOuterContainer = styled.div `
  margin: ${(props) => getMargins(props.margin) || 0};
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  --range: calc(var(--max) - var(--min));

  --thumb-diameter: ${SYS_SIZE_FIXED_600};
  --thumb-radius: calc(var(--thumb-diameter) / 2);

  --ratio0: calc((var(--value0) - var(--min)) / var(--range));
  --position0: calc(
    var(--thumb-radius) + (var(--ratio0) * (100% - var(--thumb-diameter)))
  );

  ${(props) => props.valueIsArray === true &&
    css `
      --ratio1: calc((var(--value1) - var(--min)) / var(--range));
      --position1: calc(
        var(--thumb-radius) + (var(--ratio1) * (100% - var(--thumb-diameter)))
      );

      --midpoint: calc((var(--position0) + var(--position1)) / 2);
    `}
`;
export const StyledSliderContainer = styled.div `
  height: ${SYS_SIZE_FIXED_600};
  position: relative;
`;
export const StyledControlContainer = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${SYS_SPACE_FIXED_150};
`;
export const StyledDisplayContainer = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const StyledIconButtonWrapper = styled.div `
  display: flex;
  flex-direction: column;
`;
export const StyledSlider = styled.input.attrs({
    type: 'range'
}) `
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  position: absolute;
  width: 100%;
  height: var(--thumb-diameter);
  background: transparent;
  border: none;
  margin: 0;
  padding: 0;
  opacity: 1;
  pointer-events: none;
  top: 0;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    ${injectThumb}
  }

  &::-moz-range-thumb {
    -moz-appearance: none;
    ${injectThumb}
  }

  &::-ms-thumb {
    ${injectThumb}
  }

  &::-webkit-slider-runnable-track,
  &::-moz-range-track {
    pointer-events: none;
  }

  &:focus::-moz-range-thumb,
  &:focus::-webkit-slider-thumb,
  &:focus::-ms-thumb {
    outline: 2px solid Highlight;
    outline: 2px solid -webkit-focus-ring-color;
    outline-style: auto;
  }

  &:focus-within {
    outline: none; /* Prevent default outline */
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }

  &:focus::-webkit-slider-thumb {
    outline: 2px solid Highlight;
    outline: 2px solid -webkit-focus-ring-color;
    outline-style: auto;
  }

  &:focus::-moz-range-thumb {
    outline: 2px solid Highlight;
    outline: 2px solid -webkit-focus-ring-color;
    outline-style: auto;
  }

  &:focus::-ms-thumb {
    outline: 2px solid Highlight;
    outline: 2px solid -webkit-focus-ring-color;
    outline-style: auto;
  }
`;
export const StyledTrack = styled.div `
  --gradient-direction: to right;
  height: ${SYS_SIZE_FIXED_50};
  position: relative;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);

  &::before {
    content: '';
    z-index: 2;
    width: 100%;
    position: absolute;
    inset: 0;

    ${(props) => {
    if (props.valueIsArray) {
        return css `
          background: linear-gradient(
            var(--gradient-direction),
            ${props.theme.cmp.color.forms.slider.surface.track.default}
              var(--start),
            ${props.disabled
            ? props.theme.cmp.color.forms.slider.surface.progress.disabled
            : props.invalid
                ? props.theme.cmp.color.forms.slider.surface.progress.error
                : props.theme.cmp.color.forms.slider.surface.progress.default}
              var(--start),
            ${props.disabled
            ? props.theme.cmp.color.forms.slider.surface.progress.disabled
            : props.invalid
                ? props.theme.cmp.color.forms.slider.surface.progress.error
                : props.theme.cmp.color.forms.slider.surface.progress.default}
              var(--end),
            ${props.theme.cmp.color.forms.slider.surface.track.default}
              var(--end)
          );
        `;
    }
    else {
        return css `
          background: linear-gradient(
            var(--gradient-direction),
            ${props.disabled
            ? props.theme.cmp.color.forms.slider.surface.progress.disabled
            : props.invalid
                ? props.theme.cmp.color.forms.slider.surface.progress.error
                : props.theme.cmp.color.forms.slider.surface.progress.default}
              var(--position0),
            ${props.theme.cmp.color.forms.slider.surface.track.default}
              var(--position0)
          );
        `;
    }
}}
  }

  ${(props) => props.marks.length > 0 &&
    css `
      &::after {
        content: '';
        z-index: 0;
        position: absolute;
        inset: -8px var(--thumb-radius);

        /* Using N gradients with one step here instead of one gradient with N steps due to a rendering bug in Chrome */
        background-image: ${props.marks
        .map(() => `linear-gradient(to right, transparent, ${props.theme.cmp.color.forms.slider.surface.steps.default} 0 1px)`)
        .join(', ')};
        background-position-x: ${props.marks
        .map((value) => `calc(${value} / var(--range) * 100%)`)
        .join(', ')};
        background-repeat: no-repeat;
        background-size: 1px 100%;
      }
    `}
`;
export const StyledOutputContainer = styled.div `
  display: flex;
  justify-content: center;
  ${(props) => props.valueIsArray === false &&
    css `
      justify-content: flex-start;
    `}
`;
export const StyledOutput = styled.output `
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_INPUT)};
  padding-bottom: ${SYS_SPACE_FIXED_100};

  ${(props) => props.disabled
    ? css `
          color: ${(props) => props.theme.sem.color.forms.foreground.text.disabled};
        `
    : props.invalid
        ? css `
            color: ${(props) => props.theme.sem.color.forms.foreground.text.error};
          `
        : css `
            color: ${(props) => props.theme.sem.color.forms.foreground.text.default};
          `}

  ${(props) => props.valueIsArray === false &&
    css `
      @supports (width: min(1px, 2px)) and (width: max(1px, 2px)) {
        --output-position: calc(
          max(
            0px,
            min(
              calc(var(--position0) - (var(--output-size) / 2)),
              calc(100% - var(--output-size))
            )
          )
        );
        margin-left: var(--output-position);
      }
    `}
`;
export const StyledTextContent = styled.div `
  display: flex;
  justify-content: start;
  align-items: center;
  gap: ${SYS_SPACE_FIXED_100};
  padding-bottom: ${SYS_SPACE_FIXED_50};
`;
export const StyledLabel = styled.label `
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_LABEL_SMALL)};

  color: ${(props) => props.disabled
    ? props.theme.sem.color.forms.foreground.text.disabled
    : props.invalid
        ? props.theme.sem.color.forms.foreground.text.error
        : props.theme.sem.color.forms.foreground.text.default};
`;
export const StyledAppendix = styled.div `
  color: ${(props) => props.theme.sem.color.forms.foreground.text.caption};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_APPENDIX)};
`;
export const StyledMinMax = styled.div `
  color: ${(props) => props.theme.sem.color.forms.foreground.text.caption};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_RANGE)};
  display: flex;
  justify-content: space-between;
  padding-top: ${SYS_SPACE_FIXED_100};
`;
export const StyledFormMessage = styled(FormMessage) `
  padding-top: ${SYS_SPACE_FIXED_150};
`;
//# sourceMappingURL=index.styles.js.map